import { cultivoGrpcCatalogService } from "../../modulos/catalogos/aplicaciones/services/CultivoGrpcCatalogService";
import { cultivoTratamientoGrpcCatalogService } from "../../modulos/catalogos/aplicaciones/services/CultivoTratamientoGrpcCatalogService";
import { productoGrpcCatalogService } from "../../modulos/catalogos/aplicaciones/services/ProductoGrpcCatalogService";
import { procedimientoVeterinarioGrpcCatalogService } from "../../modulos/catalogos/pesaje/ganaderia/services/ProcedimientoVeterinarioGrpcCatalogService";
import { razaAnimalGrpcCatalogService } from "../../modulos/catalogos/pesaje/ganaderia/services/RazaAnimalGrpcCatalogService";
import { tipoAnimalGrpcCatalogService } from "../../modulos/catalogos/pesaje/ganaderia/services/TipoAnimalGrpcCatalogService";
import { monitoreoCultivoPlagaGrpcCatalogService } from "../../modulos/catalogos/monitoreo/services/MonitoreoCultivoPlagaGrpcCatalogService";
import { monitoreoPlagaEnfermedadGrpcCatalogService } from "../../modulos/catalogos/monitoreo/services/MonitoreoPlagaEnfermedadGrpcCatalogService";
import { indiceGrpcCatalogService } from "../../modulos/catalogos/satelite/services/IndiceGrpcCatalogService";
import { departamentoGrpcCatalogService } from "../../modulos/catalogos/terceros/services/DepartamentoGrpcCatalogService";
// Municipio NO va en GRPC_CATALOG_SERVICES: no es catálogo plano con delta, se
// pide por departamentoId bajo demanda (ver
// MunicipioByDepartamentoIdGrpcService, usado directo desde
// AoiMapRender/AoiSearchBarRender) — pero sí se precarga en bloques más abajo
// (precargarMunicipiosDeDepartamentoAsync), ver esa función.
import { municipioByDepartamentoIdGrpcService } from "../../modulos/catalogos/terceros/services/MunicipioByDepartamentoIdGrpcService";

/** 9 catálogos, versión gRPC con delta (`BaseGrpcCatalogService`,
 *  `GrpcCatalogosDatabase`). Municipio queda afuera: no es un catálogo plano,
 *  se pide por `departamentoId` bajo demanda (ver import de arriba) — como
 *  catálogo completo se había eliminado el 2026-09-15 por peso, y así es como
 *  vuelve. DepartamentoRegion se eliminó el 2026-09-22: el wizard pasó a
 *  filtrar por municipio y era su único consumidor. */
const GRPC_CATALOG_SERVICES = [
  cultivoGrpcCatalogService,
  cultivoTratamientoGrpcCatalogService,
  productoGrpcCatalogService,
  tipoAnimalGrpcCatalogService,
  razaAnimalGrpcCatalogService,
  procedimientoVeterinarioGrpcCatalogService,
  indiceGrpcCatalogService,
  monitoreoPlagaEnfermedadGrpcCatalogService,
  monitoreoCultivoPlagaGrpcCatalogService,
  departamentoGrpcCatalogService,
];

/** Precarga todos los catálogos en segundo plano (fire-and-forget, no
 *  bloquea el montaje del layout). Cada `syncAsync()` ya resuelve el
 *  watermark solo, así que en aperturas posteriores esto es prácticamente
 *  gratis. Se llama una sola vez en `BaseInit._initLayout`, cubriendo tanto
 *  el login por token como el login por formulario. */
export function syncAllCatalogsInBackground(): void {
  GRPC_CATALOG_SERVICES.forEach((service) => {
    service.syncAsync().catch((error) => {
      console.warn("[catalogSync] Falló la sincronización gRPC de un catálogo:", error);
    });
  });

  precargarMunicipiosDeDepartamentoAsync().catch((error) => {
    console.warn("[catalogSync] Falló la precarga de municipios de departamento:", error);
  });
}

/** Cuántos departamentos se piden en paralelo por tanda: ni los 33
 *  de una (pico innecesario justo al loguear) ni uno por uno (33 round-trips
 *  serializados) — pedido explícito, "en bloques de 5 o 10". */
const TAMANO_BLOQUE_MUNICIPIOS = 8;

/** Precarga los municipios de todos los departamentos, en bloques, apenas
 *  termina de sincronizar el catálogo de Departamento. `AoiMapRender`/
 *  `AoiSearchBarRender` los piden por `departamentoId`
 *  (`MunicipioByDepartamentoIdGrpcService`, que cachea en memoria e
 *  IndexedDB) — sin esto, la primera vez que el usuario elige un departamento
 *  en el wizard espera ese round-trip; con esto, para cuando llega ahí, la
 *  mayoría ya está cacheada. Un departamento que falla no frena a los demás
 *  (`.catch` por item, dentro del bloque). */
async function precargarMunicipiosDeDepartamentoAsync(): Promise<void> {
  const departamentos = await departamentoGrpcCatalogService.getListAsync();

  for (let i = 0; i < departamentos.length; i += TAMANO_BLOQUE_MUNICIPIOS) {
    const bloque = departamentos.slice(i, i + TAMANO_BLOQUE_MUNICIPIOS);
    await Promise.all(
      bloque.map((departamento) =>
        municipioByDepartamentoIdGrpcService
          .getListAsync(departamento.id)
          .catch((error) => {
            console.warn(
              `[catalogSync] Falló la precarga de municipios del departamento ${departamento.id}:`,
              error,
            );
          }),
      ),
    );
  }
}
